import SpecialtyRelatedLinks, {
  SpecialtyRelatedLinksProps,
} from '@/features/specialty-page/components/specialty-related-links';
import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';

export default function RelatedLinksRenderer(props: unknown) {
  const isSpecialtyPage = !!useSpecialtyPageContext().specialty;
  if (isSpecialtyPage) {
    return <SpecialtyRelatedLinks {...(props as SpecialtyRelatedLinksProps)} />;
  }

  return null;
}
